const state = {
  invoiceBodyOpts: [],
  invoiceProviderOpts: [],
  taxClassificationOpts: [],
}

const getters = {
  getInvoiceBodyOpts: (state) => {
    return state.invoiceBodyOpts
  },

  getInvoiceProviderOpts: (state) => {
    return state.invoiceProviderOpts
  },

  getTaxClassificationOpts: (state) => {
    return state.taxClassificationOpts
  },
}

const mutations = {
  setInvoiceBodyOpts(state, list) {
    state.invoiceBodyOpts = list
  },

  setInvoiceProviderOpts(state, list) {
    state.invoiceProviderOpts = list
  },

  setTaxClassificationOpts(state, list) {
    state.taxClassificationOpts = list
  },
}

const actions = {
  // 发票主体列表
  async getInvoiceBodyOptsAction({ commit }) {
    try {
      const res = await API.httpGet('/invoice_body/list')
      if (Array.isArray(res) && res.length) {
        commit('setInvoiceBodyOpts', res)
      }
    } catch (e) {
      console.error(e)
    }
  },

  // 开票商列表
  async getInvoiceProviderOptsAction({ commit }) {
    try {
      const res = await API.httpGet('/invoice_provider/list')
      if (Array.isArray(res) && res.length) {
        commit('setInvoiceProviderOpts', res)
      }
    } catch (e) {
      console.error(e)
    }
  },

  // 发票类目列表
  async getTaxClassificationOptsAction({ commit }) {
    try {
      const res = await API.httpGet('/tax_classification/list')
      if (Array.isArray(res) && res.length) {
        commit('setTaxClassificationOpts', res)
      }
    } catch (e) {
      console.error(e)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
